import React, { MouseEvent, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Datatable, { PagingTypeEnum } from '../Datatable/Datatable';
import DatatableColumnModel from '../Datatable/DatatableColumnModel';
import { setSelectedPortId, setSelectedPortIndex, setTriggerRefreshTable, setPortInput, setOrderBy, setOrderDirection, setCargoTypesearchText, setCargoTypes } from './reducers/CargoTypeManagementReducer';
import _ from 'lodash';
import { OrderDirection } from '../Datatable/OrderDirection';
import CargoTypeModel from '../CargoTypeSelector/models/CargoTypeModel';
import { cargoTypeManagerSelector } from './reducers/CargoTypeManagementReducer';
import { Button, Tooltip } from '@mui/material';
import Swal from 'sweetalert2';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import CargoTypeSelectorApi, { DeleteCargoTypeParam } from '../CargoTypeSelector/api/CargoTypeSelectorApi';
import Utility from '../../app/utility';
import BaseResponse from '../../app/BaseResponse';

const CargoTypeManagementTable: React.FunctionComponent = () => {
    let dispatch = useDispatch();

    let portManagementData = useSelector(cargoTypeManagerSelector);

    const columns = [
        {
            Field: "name",
            Title: "Name",
            AllowSort: true,
        } as DatatableColumnModel<CargoTypeModel>,
        {
            Field: "cargoGroupName",
            Title: "Group",
            AllowSort: true,
        } as DatatableColumnModel<CargoTypeModel>,
        {
            Field: "",
            Title: "",
            AllowSort: false,
            Render: (rowData: CargoTypeModel) => (
                <>
                    <Tooltip title="Delete Cargo Type">
                        <Button
                            className='table-action-button'
                            variant='outlined'
                            color='error'
                            onClick={() => {
                                deleteCargoType(rowData.id)
                            }}
                        >
                            <i className="fa fa-trash" aria-hidden="true"></i>
                        </Button>
                    </Tooltip>
                </>
            )
        } as DatatableColumnModel<CargoTypeModel>,
    ];

    const getTableClassName = () => {
        let className = "cargo-type-management-datatable-search-result nice-scroll";

        if (!portManagementData.inputExpand) {
            className += " cargo-type-management-datatable-search-result-input-collapse";
        }

        return className;
    }

    const deleteCargoType = (id: number) => {
        Swal.fire({
            title: 'Are you sure want to delete this cargo tpe? This action can not be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(showLoading(true));
                CargoTypeSelectorApi.DeleteCargoType({
                    id: id
                } as DeleteCargoTypeParam)
                    .then((response: BaseResponse<string>) => {
                        if (response.success) {
                            Utility.Alert.Success("Cargo type deleted successful");

                            dispatch(showLoading(false));

                            dispatch(setTriggerRefreshTable(new Date().getTime()));
                        }
                    });
            }
        })
    };

    return <div className='cargo-type-datatable-wrapper'>
        <Datatable<CargoTypeModel>
            useDefaultSearchBar={true}
            onSearchValueChange={(value: string) => {
                dispatch(setCargoTypesearchText(value));
                let data = _.filter([...portManagementData.cargoTypesCache], (item) => {
                    return item.name.indexOf(value.toUpperCase()) > -1 || (item.cargoGroupName != null && item.cargoGroupName.indexOf(value.toUpperCase()) > -1);
                })
                dispatch(setCargoTypes(data));
            }}
            pagingType={PagingTypeEnum.None}
            data={portManagementData.cargoTypes}
            useItemPerPage={false}
            columns={columns}
            isDataLoaded={true}
            className={getTableClassName()}
            useHeaderSort={true}
            onOrderDirectionChange={(column: DatatableColumnModel<CargoTypeModel>, orderDirection: OrderDirection) => {
                dispatch(setOrderBy(column.Field));
                dispatch(setOrderDirection(orderDirection));

                let data = [...portManagementData.cargoTypes];
                if (orderDirection == OrderDirection.Asc) {
                    data = _.sortBy(data, column.Field);
                } else {
                    data = _.sortBy(data, column.Field).reverse();
                }

                dispatch(setCargoTypes(data));
            }}
            orderColumn={portManagementData.orderBy}
            orderDirection={portManagementData.orderDirection}
            onRowSelectedChange={(port: CargoTypeModel, index: number, event: MouseEvent<HTMLElement>) => {
                var target = event.target as HTMLElement;
                if (target.tagName !== "BUTTON") {
                    dispatch(setSelectedPortIndex(index));
                    dispatch(setSelectedPortId(port.id));
                    dispatch(setPortInput(port));
                }
            }}
            selectedRowIndex={portManagementData.selectedIndex}
            stickyHeader={true}
        ></Datatable>
    </div>
};

export default CargoTypeManagementTable;